import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import FooterCTA from './components/FooterCTA';
import Home from './pages/Home';
import AllCourses from './pages/AllCourses';
import CourseDetail from './pages/CourseDetail';
import QuickSupport from './pages/QuickSupport';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<AllCourses />} />
          <Route path="/courses/:path" element={<CourseDetail />} />
          <Route path="/support" element={<QuickSupport />} />
        </Routes>
        <FooterCTA />
      </div>
    </Router>
  );
}

export default App;
